import { render } from "./future.vue?vue&type=template&id=b0a08c60&scoped=true"
import script from "./future.vue?vue&type=script&lang=js"
export * from "./future.vue?vue&type=script&lang=js"

import "./future.vue?vue&type=style&index=0&id=b0a08c60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a08c60"]])

export default __exports__